class Cache
  constructor: ->
    @data = {}

  get: (key) ->
    @data[key]

  set: (key, value) ->
    @data[key] = value

  remove: (key) ->
    delete @data[key]

module.exports = new Cache



// WEBPACK FOOTER //
// ./src/libraries/cache.coffee